module.exports = __webpack_public_path__ + "img/6.50d452b3.webp";